<section class="env-section">
    <div class="container">

        <!-- Page Header -->
        <div class="header">
            <h3 class="page-title">Environment Variables</h3>

        </div>

        <p-accordion [multiple]="true">

            <!-- ADMIN DEFAULTS -->
            <p-accordionTab header="Admin Defaults">

                <div class="form-row">
                    <label>Email</label>
                    <input type="text" [(ngModel)]="env.admin.email" (input)="updateJson()" placeholder="Admin Email">
                </div>

                <div class="form-row">
                    <label>Password</label>
                    <input type="password" [(ngModel)]="env.admin.password" (input)="updateJson()"
                        placeholder="Admin Password">
                </div>

                <div class="form-row">
                    <label>Roles</label>
                    <input type="text" [(ngModel)]="env.admin.roles" (input)="updateJson()"
                        placeholder="SUPER_ADMIN,ADMIN">
                </div>

            </p-accordionTab>

            <!-- MAIL CONFIG -->
            <p-accordionTab header="Mail Server">

                <div class="form-row">
                    <label>Redirect URI</label>
                    <input type="text" [(ngModel)]="env.mail.redirectUri" (input)="updateJson()"
                        placeholder="http://your-app-url">
                </div>

                <div class="form-row">
                    <label>Host</label>
                    <input type="text" [(ngModel)]="env.mail.host" (input)="updateJson()"
                        placeholder="smtp.hostinger.com">
                </div>

                <div class="form-row">
                    <label>Port</label>
                    <input type="number" [(ngModel)]="env.mail.port" (input)="updateJson()" placeholder="465">
                </div>

                <div class="form-row">
                    <label>Username</label>
                    <input type="text" [(ngModel)]="env.mail.username" (input)="updateJson()"
                        placeholder="email@domain.com">
                </div>

                <div class="form-row">
                    <label>Password</label>
                    <input type="password" [(ngModel)]="env.mail.password" (input)="updateJson()"
                        placeholder="Mail password">
                </div>

                <div class="form-row">
                    <label>Protocol</label>
                    <input type="text" [(ngModel)]="env.mail.protocol" (input)="updateJson()" placeholder="smtp">
                </div>

                <div class="form-row">
                    <label>SSL Trust</label>
                    <input type="text" [(ngModel)]="env.mail.sslTrust" (input)="updateJson()"
                        placeholder="smtp.hostinger.com">
                </div>

                <div class="form-row">
                    <label>Auth Enabled</label>
                    <input type="checkbox" [(ngModel)]="env.mail.auth" (change)="updateJson()">
                </div>

                <div class="form-row">
                    <label>SSL Enabled</label>
                    <input type="checkbox" [(ngModel)]="env.mail.sslEnable" (change)="updateJson()">
                </div>

                <div class="form-row">
                    <label>StartTLS</label>
                    <input type="checkbox" [(ngModel)]="env.mail.starttlsEnable" (change)="updateJson()">
                </div>

                <div class="form-row">
                    <label>Connection Timeout</label>
                    <input type="number" [(ngModel)]="env.mail.connectionTimeout" (input)="updateJson()"
                        placeholder="5000">
                </div>

                <div class="form-row">
                    <label>Timeout</label>
                    <input type="number" [(ngModel)]="env.mail.timeout" (input)="updateJson()" placeholder="5000">
                </div>

                <div class="form-row">
                    <label>Write Timeout</label>
                    <input type="number" [(ngModel)]="env.mail.writeTimeout" (input)="updateJson()" placeholder="5000">
                </div>

            </p-accordionTab>

            <!-- OTP -->
            <p-accordionTab header="OTP Settings">

                <div class="form-row">
                    <label>Expiration (ms)</label>
                    <input type="number" [(ngModel)]="env.otp.expiration" (input)="updateJson()" placeholder="900000">
                </div>

                <div class="form-row">
                    <label>OTP Length</label>
                    <input type="number" [(ngModel)]="env.otp.length" (input)="updateJson()" placeholder="6">
                </div>

            </p-accordionTab>

            <p-accordionTab header="Callbacks">

                <div class="form-row">
                    <label>User Created Callback URL</label>
                    <input type="text" [(ngModel)]="env.callbacks.userCreated" (input)="updateJson()"
                        placeholder="https://project.com/api/auth/user-created">
                </div>

            </p-accordionTab>


        </p-accordion>
    </div>
</section>